import moment from "moment";

export const options = (data: any, windownHeight: any, fontSizeLabel: any) => {
  let maxPrice = data.buyPoint[0]
  let minPrice = data.buyPoint[0]

  data.sellPoint.map((item: any) => {
    if (item > maxPrice) {
      maxPrice = item
    }
    if (item < minPrice) {
      minPrice = item
    }
  })
  data.sellPoint.map((item: any) => {
    if (item > maxPrice) {
      maxPrice = item
    }
    if (item < minPrice) {
      minPrice = item
    }
  })

  return {
    chart: {
      type: 'spline',
      backgroundColor: 'transparent',
      zoomType: 'xy',
      spacingLeft: 0,
      spacingRight: 0,
      height: windownHeight
    },
    title: {
      text: ''
    },
    xAxis: {
      labels: {
        enabled: false,
      },
      title: {
        text: ''
      },
      minorTickLength: 0,
      tickLength: 0,
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      lineWidth: 0,
    },
    yAxis: [{
      min: minPrice,
      max: maxPrice,
      minorTickLength: 0,
      tickLength: 0,
      gridLineWidth: 0.5,
      gridLineColor: '#4D4D4D',
      minorGridLineWidth: 0,
      lineWidth: 0,
      title: {
        text: '',
        style: {
          color: '#ffffff'
        }
      },
      labels: {
        style: {
          color: '#ffffff',
          fontSize: fontSizeLabel,
        },
        formatter: function (item: any) {
          return `${item?.value}%`;
        }
      },
      plotBands: [{
        from: 30,
        to: maxPrice + 5,
        color: {
          linearGradient: { x1: 1, y1: 1, x2: 1, y2: 0 },
          stops: [
            [0, '#cb1c4614'],
            [1, '#cb1c4657'],
          ]
        },
      }, {
        from: 0,
        to: 15,
        color: {
          linearGradient: { x1: 1, y1: 1, x2: 1, y2: 0 },
          stops: [
            [0, '#2ab03540'],
            [1, '#97df9d0d'],
          ]
        },
      }]
    }],
    plotOptions: {
      spline: {
        dashStyle: 'ShortDash'
      },
      series: {
        states: {
          // inactive: {
          //   opacity: 1
          // }
        }
      },
    },
    legend: {
      enabled: false,
      itemStyle: {
        color: '#ffffff'
      }
    },
    tooltip: {
      shared: true,
      enabled: true,
      useHTML: true,
      borderRadius: 0,
      borderWidth: 0,
      backgroundColor: '#131313',
      formatter: function () {
        const thisData: any = this
        const points = thisData?.points
        let index = null
        if (points.length > 0) {
          points.map((item: any) => {
            index = item.point.index
          })
        }

        if (index) {
          return `<div class="ioalomryco">
          <div class="fzlgnzcgwl whlqpruvka">Ngày: ${moment(data?.tradingdate[index]).format('DD/MM/YYYY')} </div>
          <div class="fzlgnzcgwl fzbjtfpdgt">Tín hiệu mua: ${data?.buyPoint?.[index]?.toFixed(2)}</div>
          <div class="fzlgnzcgwl fzbjtfpdgt">Tín hiệu bán: ${data?.sellPoint?.[index]?.toFixed(2)}</div>
          </div>`;
        }
      }
    },
    series: [{
      data: data?.buyPoint,
      name: 'Đà lan toả toàn thị trường',
      color: '#2AD03D',
      lineWidth: 0.8,
      marker: {
        lineWidth: 0,
        radius: 4,
      },
    }, {
      data: data?.sellPoint,
      name: 'MA 10',
      color: '#F7931A',
      lineWidth: 0.8,
      marker: {
        lineWidth: 0,
        radius: 4,
      },
    }]
  }
}